<div class="redirect-container">
  <div class="redirect-content">
    <p class="redirect-message">
      You are not registered to use this application, maybe you are registered to use the Account Manager Portal. Try clicking the button below to redirect to the Account Manager Portal
    </p>
    <button class="redirect-button" (click)="redirectToPortal()">
      Go to AM Portal
    </button>
  </div>
</div>
